import { useEffect, useState } from "react";
import type {
  SearchOption,
  SearchOptionPaginationControl,
} from "../../types/searchSessions";
import SearchableSelect from "../SearchableSelect";

interface CourtSelectFieldProps {
  id: string;
  label: string;
  options: SearchOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder: string;
  paginationControl?: SearchOptionPaginationControl;
}

const CourtSelectField = ({
  id,
  label,
  options,
  value,
  onChange,
  disabled = false,
  placeholder,
  paginationControl,
}: CourtSelectFieldProps) => {
  const [selectedOption, setSelectedOption] = useState<SearchOption | null>(
    null,
  );
  const optionFromCurrentPage =
    options.find((option) => option.value === value) || null;
  const displayValue =
    optionFromCurrentPage ||
    (selectedOption?.value === value ? selectedOption : null);

  useEffect(() => {
    if (!value) {
      setSelectedOption(null);
      return;
    }

    if (optionFromCurrentPage) {
      setSelectedOption(optionFromCurrentPage);
    }
  }, [optionFromCurrentPage, value]);

  return (
    <div>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        {label} *
      </label>
      <SearchableSelect
        options={options}
        value={displayValue}
        onChange={(selected: any) => {
          setSelectedOption(selected || null);
          onChange(selected?.value || "");
        }}
        disabled={disabled}
        placeholder={placeholder}
        className="w-full"
        onSearchChange={paginationControl?.onSearchChange}
        onLoadMore={paginationControl?.onLoadMore}
        hasMore={paginationControl?.hasMore}
        isLoadingMore={paginationControl?.isLoadingMore}
        isLoadingOptions={paginationControl?.isLoading}
      />
    </div>
  );
};

export default CourtSelectField;
